import store from "store";
import eventPlugin from "store/plugins/events";
import { StoreJsAPILike } from "./types";

store.addPlugin(eventPlugin);

export const sessionStore: StoreJsAPILike = store as any;
